<template>
  <v-dialog
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    max-width="600px"
  >
    <v-tabs
      v-model="tab"
      show-arrows
      background-color="#E35205"
      icons-and-text
      dark
      grow
    >
      <v-tabs-slider color="blue"></v-tabs-slider>
      <v-tab v-for="item in tabs" :key="item.name_EN">
        <v-icon large>{{ item.icon }}</v-icon>
        <div class="caption py-1">
          {{ objectTranslator(item, "name") }}
        </div>
      </v-tab>
      <!-- Login -->
      <v-tab-item>
        <v-card
          :disabled="loginFormLoading"
          :loading="loginFormLoading"
          class="px-4"
        >
          <v-card-text>
            <v-card class="px-5 pt-5" color="grey lighten-4">
              <v-form
                ref="loginForm"
                v-model="loginFormValid"
                @submit.prevent=""
              >
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="loginEmail"
                      :rules="loginEmailRules"
                      v-bind:label="$t('login.email')"
                      class="mt-5"
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="loginPassword"
                      :append-icon="show_password ? 'eye' : 'eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="show_password ? 'text' : 'password'"
                      name="input-10-1"
                      v-bind:label="$t('login.password')"
                      hint="At least 8 characters"
                      counter
                      outlined
                      dense
                      @click:append="show_password = !show_password"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-btn
                      large
                      :disabled="!loginFormValid"
                      color="primary"
                      type="submit"
                      @click="login()"
                      >{{ $t("login.login") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
            <v-row>
              <v-col>
                <v-expansion-panels class="mx-auto mt-5">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="grey--text text--darken-1">
                      {{ $t("login.officer_authen") }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card
                        max-width="500"
                        class="rounded-0 mx-auto"
                        elevation="0"
                      >
                        <v-card-actions>
                          <v-btn
                            large
                            class="mx-auto pl-5 pr-5"
                            color="primary"
                            @click="loginKeycloak()"
                          >
                            {{ $t("login.login") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined @click="$emit('input', false)">{{
              $t("confirm_regis.close")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <!-- Register -->
      <v-tab-item>
        <v-card
          :loading="registerFormLoading"
          :disabled="registerFormLoading"
          class="px-4"
        >
          <v-card-text>
            <v-card class="px-5 pt-5" color="grey lighten-4">
              <v-form ref="registerForm" v-model="registerFormValid">
                <ThaiOrOtherCard
                  v-model="createAccountThaiOrOtherNation"
                  v-bind:textThai="$t('info_card.nation_thai')"
                  v-bind:textOther="$t('info_card.nation_foreigner')"
                />
                <!-- ทำยังไงถ้า CitizenID มีให้กรอกทั้งในสัญชาติไทยและต่างชาติ ปล.ตอนนี้ใช้ตัวแปรเดียวกัน ถ้ากรอกสลับไปมา ค่าที่ใช้จะเป็นอันไหน -->
                <CitizenIDCard
                  v-model="createAccountCitizenId"
                  v-if="this.createAccountThaiOrOtherNation === 'thai'"
                />
                <CitizenOrPassportCard
                  v-model="createAccountCitizenOrPassport"
                  v-if="this.createAccountThaiOrOtherNation === 'other'"
                />
                <PassportNumberCard
                  v-model="createAccountPassportNumber"
                  v-if="
                    this.createAccountThaiOrOtherNation === 'other' &&
                    this.createAccountCitizenOrPassport === 'passport'
                  "
                />
                <CitizenIDCard
                  v-model="createAccountCitizenId"
                  v-if="
                    this.createAccountThaiOrOtherNation === 'other' &&
                    this.createAccountCitizenOrPassport === 'citizen'
                  "
                />
                <EmailCard v-model="createAccountEmail" />
                <v-row>
                  <v-col class="text-center">
                    <v-btn
                      large
                      color="primary"
                      :disabled="!registerFormValid"
                      @click="submitcreateaccount"
                    >
                      {{ $t("login.register") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p class="red--text font-weight-bold">
                      {{ $t("login.spam_mail_notice") }}
                    </p>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined @click="$emit('input', false)">{{
              $t("confirm_regis.close")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <!-- Forgot password -->
      <v-tab-item>
        <v-card
          :disabled="forgetPassFormLoading"
          :loading="forgetPassFormLoading"
          class="px-4"
        >
          <v-card-text>
            <v-card class="px-5 pt-5" color="grey lighten-4">
              <v-form ref="forgetPassForm" v-model="forgetPassFormValid">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="forgotPasswordInfo"
                      v-bind:label="$t('login.forgot_password_label')"
                      v-bind:placeholder="$t('login.forgot_password_hint')"
                      v-bind:rules="forgotDataRules"
                      class="mt-5"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-spacer></v-spacer> -->
                <v-row>
                  <v-col class="text-center">
                    <v-btn
                      large
                      :disabled="!forgetPassFormValid"
                      color="primary"
                      @click="submitResetPassword"
                    >
                      {{ $t("login.forgot_password") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <!-- <v-spacer></v-spacer> -->
                <v-row>
                  <v-col>
                    <p class="red--text font-weight-bold">
                      {{ $t("login.spam_mail_notice") }}
                    </p>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined @click="$emit('input', false)">{{
              $t("confirm_regis.close")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <v-row v-if="app_mode === 'local'" style="padding: 15px">
      <v-col cols="4">
        <v-text-field
          v-model="local_1"
          label="local 1"
          name="local_1"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="local_2"
          label="local 2"
          name="local_2"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-btn outlined @click="good_morning()">Good Morning</v-btn>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";
import ThaiOrOtherCard from "@/components/info_cards/ThaiOrOther";
import CitizenOrPassportCard from "@/components/info_cards/CitizenOrPassport";
import CitizenIDCard from "@/components/info_cards/CitizenID";
import PassportNumberCard from "@/components/info_cards/PassportNumber";
import EmailCard from "@/components/info_cards/Email";
import AuthProvider from "@/services/auth.provider";
// import GenericProvider from "@/services/generic.provider";
import { createHelpers } from "vuex-map-fields";

const { mapFields: paramsFields } = createHelpers({
  getterType: "params/getField",
  mutationType: "params/updateField",
});

const authService = new AuthProvider();
// const genericService = new GenericProvider();

export default {
  name: "Login_Regis_Forgot",
  props: {
    value: Boolean,
  },
  data: function () {
    return {
      dialog: true,
      tab: 0,
      tabs: [
        { name_TH: "เข้าสู่ระบบ", name_EN: "Login", icon: "mdi-account" },
        {
          name_TH: "ลงทะเบียน",
          name_EN: "Register",
          icon: "mdi-account-outline",
        },
        {
          name_TH: "ลืมรหัสผ่าน ?",
          name_EN: "Forgot password ?",
          icon: "mdi-lock-question",
        },
      ],
      show_password: false,

      loginFormValid: null,
      registerFormValid: null,
      forgetPassFormValid: null,
      loginFormLoading: false,
      registerFormLoading: false,
      forgetPassFormLoading: false,

      local_1: null,
      local_2: null,

      loginEmail: null,
      loginPassword: null,

      createAccountEmail: null,
      createAccountThaiOrOtherNation: null,
      createAccountCitizenId: null,
      createAccountCitizenOrPassport: null,
      createAccountPassportNumber: null,

      forgotPasswordInfo: null,

      loginEmailRules: [validator.required, validator.email],
      emailRules: [validator.required, validator.email],
      forgotDataRules: [validator.required],

      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => (v && v.length >= 8) || "Min 8 characters",
      },
    };
  },
  components: {
    ThaiOrOtherCard,
    CitizenOrPassportCard,
    CitizenIDCard,
    PassportNumberCard,
    EmailCard,
  },
  methods: {
    objectTranslator,
    //-------------------------------------------
    async login() {
      if (this.$refs.loginForm.validate()) {
        this.loginFormLoading = true;
        const response = await authService
          .login({
            username: this.loginEmail,
            password: this.loginPassword,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.loginFormLoading = false;
          });
        if (response?.token && response?.uid) {
          localStorage.setItem("token", response.token);
          localStorage.setItem("uid", response.uid);
          this.open_login_dialog = false;
          window.location.reload();
        }
        this.loginFormLoading = false;
      }
    },
    loginKeycloak() {
      this.$store.dispatch("keycloak/login");
    },
    //-------------------------------------------
    async submitcreateaccount() {
      if (this.$refs.registerForm.validate()) {
        this.registerFormLoading = true;
        const response = await authService
          .createAccount({
            CREATE_USER_ACCOUNT_AS_INTER:
              this.createAccountThaiOrOtherNation === "other" ? 1 : 0,
            EMAIL: this.createAccountEmail,
            CITIZEN_ID: this.createAccountCitizenId,
            PASSPORT_ID: this.createAccountPassportNumber,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.registerFormLoading = false;
          });
        if (response && response.status) {
          this.registerFormLoading = false;
          this.open_login_dialog = false;
          this.$toasted.success(this.$t("toasted.mail_sent"), { duration: 0 });
        }
      }
    },
    //-------------------------------------------
    async submitResetPassword() {
      if (this.$refs.forgetPassForm.validate()) {
        this.forgetPassFormLoading = true;
        const response = await authService
          .requestPassword({
            CITIZEN_ID: this.forgotPasswordInfo,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.forgetPassFormLoading = false;
          });
        if (response && response.status) {
          this.forgetPassFormLoading = false;
          this.open_login_dialog = false;
          this.$toasted.success(
            this.$t("toasted.mail_sent_to") + " " + response.EMAIL,
            {
              duration: 0,
            }
          );
        }
      }
    },
    //-------------------------------------------
    async good_morning() {
      // await genericService.dummie(this.local_1, this.local_2);
      window.location.reload();
    },
  },
  computed: {
    app_mode() {
      return process.env.VUE_APP_MODE;
    },
    ...paramsFields({
      open_login_dialog: "open_login_dialog",
    }),
  },
};
</script>
